// @TODO: combine with listitem?
/**
 * Ryan O'Dowd
 * 2023-08-23
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';

// @TODO: instead of the `WithRightItem` styles, this should be handled by the components using this component
const getStyles = ({fonts, globalScale, colors, isDarkMode, theme}) => {
  // @TODO: verify that all of these gradients look good (mobile too)
  // @TODO: gradients should show on native as well
  let gradientPrimaryLight = colors.primaryDark;
  let gradientPrimaryDark = colors.primaryExtraDark;
  let gradientWhiteLight = colors.white;
  let gradientWhiteDark = colors.black;
  let gradientCompleted = colors.completeBg;
  if (Platform.OS === 'web') {
    gradientPrimaryLight = `linear-gradient(
      ${colors.primary} 0%,
      ${colors.primaryDark} 100%
    )`;
    gradientPrimaryDark = `linear-gradient(
      ${colors.primaryDark} 0%,
      ${colors.primaryExtraDark} 100%
    )`;
    gradientCompleted = `linear-gradient(
      ${colors.completeBg} 0%,
      ${colors.black} 100%
    )`;
    gradientWhiteLight = `linear-gradient(
      ${colors.white} 0%,
      ${colors.white} 100%
    )`;
    // @TODO: don't use black-black
    gradientWhiteDark = `linear-gradient(
      ${colors.black} 0%,
      ${colors.black} 100%
    )`;
    /* @TODO:
    gradientWhiteLight = `linear-gradient(
      ${colors.white} 0%,
      ${colors.lightGray} 100%
    )`;
    gradientWhiteDark = `linear-gradient(
      ${colors.gray} 0%,
      ${colors.black} 100%
    )`;
    */
  }
  let backgroundColoring;
  let borderColoring;
  switch (theme) {
  case 'white': {
    if (isDarkMode) {
      backgroundColoring = gradientWhiteDark;
      borderColoring = colors.gray;
    } else {
      backgroundColoring = gradientWhiteLight;
      borderColoring = colors.lightGray;
    }
    break;
  }
  case 'completed': {
    backgroundColoring = gradientCompleted;
    borderColoring = colors.accent;
    break;
  }
  default: {
    if (isDarkMode) {
      backgroundColoring = gradientPrimaryDark;
      borderColoring = colors.primary;
    } else {
      backgroundColoring = gradientPrimaryLight;
      borderColoring = colors.primaryLight;
    }
    break;
  }
  }

  return {
    container: {
      display: 'flex',
      flexGrow: 1,
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      width: '100%',
      backgroundColor: backgroundColoring,
      backgroundImage: backgroundColoring,
      borderColor: borderColoring,
      borderWidth: globalScale * 4,
      borderRadius: globalScale * 12,
      marginVertical: globalScale * 2,
      minHeight: 'initial', // @TODO: need this on web, otherwise "add new assignment" accordion is too tall
    },
    touchableAccordion: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: globalScale * 4,
    },
    disabled: {
      opacity: 0.6,
    },
    row: {
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    leftItemWrapper: {
      marginRight: globalScale * 4,
    },
    rightItemWrapper: {
      marginLeft: globalScale * 4,
    },
    alignWithTop: {
      alignSelf: 'flex-start',
    },
    titleAndSubtitle: {
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      marginLeft: globalScale * 4,
    },
    noLeftMargin: {
      marginLeft: 0,
    },
    titleText: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: globalScale * 16,
      fontFamily: fonts.secondaryBold,
      color: (theme === 'white' && !isDarkMode) ? colors.primaryDark : colors.primaryExtraLight,
    },
    subtitleText: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: globalScale * 14,
      fontFamily: fonts.primary,
      color: (theme === 'white' && !isDarkMode) ? colors.accentDark : colors.accent,
    },
    childrenWrapper: {
      flex: 1,
      width: '100%',
      padding: globalScale * 8,
      borderTopWidth: 0,
    },
  };
};

export default getStyles;
